//PLEASE KEEP ALPHABETICAL ORDER
export const icons = {
  about: require('../assets/icons/about/about.png'),
  alert: require('../assets/icons/alert/alert.png'),
  arrowBack: require('../assets/icons/arrows/arrowBack.png'),
  arrowDown: require('../assets/icons/arrows/arrowDownIcon.png'),
  arrowUp: require('../assets/icons/arrows/arrowUp.png'),
  assistance: require('../assets/icons/assistance/assistance.png'),
  avatarLogin: require('../assets/icons/avatarLogin/avatarLogin.png'),
  building: require('../assets/icons/building/building.png'),
  calendarIcon: require('../assets/icons/constructionModule/calendarIcon.png'),
  checkCircleIcon: require('../assets/icons/financeBills/checkCircleIcon.png'),
  chevronLeft: require('../assets/icons/chevronLeft/chevronLeft.png'),
  close: require('../assets/icons/close/close.png'),
  construction: require('../assets/icons/constructionModule/construction.png'),
  constructionsMedia: require('../assets/icons/constructionsMedia/constructionsMedia.png'),
  copyIcon: require('../assets/icons/financeBills/copyIcon.png'),
  date: require('../assets/icons/date/date.png'),
  dateRange: require('../assets/icons/dateRange/dateRange.png'),
  delete: require('../assets/icons/delete/delete.png'),
  dismiss: require('../assets/icons/dismiss/dismiss.png'),
  download: require('../assets/icons/download/download.png'),
  floorPlanIcon: require('../assets/icons/constructionModule/floorPlanIcon.png'),
  formatPaintIcon: require('../assets/icons/constructionModule/formatPaintIcon.png'),
  home: require('../assets/icons/home/home.png'),
  keyIcon: require('../assets/icons/notifications/keyIcon.png'),
  larLondres: require('../assets/icons/constructionModule/larLondres.png'),
  location: require('../assets/icons/location/location.png'),
  locationIcon: require('../assets/icons/constructionModule/locationIcon.png'),
  lock: require('../assets/icons/lock/lock.png'),
  logout: require('../assets/icons/logout/logout.png'),
  menu: require('../assets/icons/menu/menu.png'),
  mobilePhone: require('../assets/icons/mobilePhone/mobilePhone.png'),
  monetization: require('../assets/icons/monetization/monetization.png'),
  monetizationDashboard: require('../assets/icons/dashboard/monetization.png'),
  homeDashboard: require('../assets/icons/dashboard/home.png'),
  rangeDashboard: require('../assets/icons/dashboard/range.png'),
  alertDashboard: require('../assets/icons/dashboard/alert.png'),
  profileDashboard: require('../assets/icons/dashboard/profile.png'),
  assistanceDashboard: require('../assets/icons/dashboard/assistance.png'),
  moneyIcon: require('../assets/icons/monetization/moneyIcon.png'),
  noNotifications: require('../assets/icons/noNotifications/noNotifications.png'),
  notifications: require('../assets/icons/notifications/notifications.png'),
  onboardingConstruction: require('../assets/icons/onboarding/constructionIcon.png'),
  onboardingFinancing: require('../assets/icons/onboarding/financingIcon.png'),
  onboardingNotification: require('../assets/icons/onboarding/notificationIcon.png'),
  openLock: require('../assets/icons/openLock/openLock.png'),
  photo: require('../assets/icons/photo/photo.png'),
  privacy: require('../assets/icons/privacy/privacy.png'),
  profile: require('../assets/icons/profile/profile.png'),
  share: require('../assets/icons/share/share.png'),
  time: require('../assets/icons/time/time.png'),
  towerIcon: require('../assets/icons/constructionModule/towerIcon.png'),
  videos: require('../assets/icons/videos/videos.png'),
  wallIcon: require('../assets/icons/constructionModule/wallIcon.png'),
  wallet: require('../assets/icons/wallet/wallet.png'),
  warningIcon: require('../assets/icons/financeBills/warningIcon.png'),
  warningOutlineIcon: require('../assets/icons/financeBills/warningOutlineIcon.png'),
  zoomOut: require('../assets/icons/zoomOut/zoomOut.png'),
  mainLogo: require('../assets/images/mainLogo/logo.png'),
}

export const iconsWebApp = {
  monetization: require('../assets/icons/monetization/monetization6x.png'),
  home: require('../assets/icons/home/home6x.png'),
  assistance: require('../assets/icons/assistance/assistance6x.png'),
  notifications: require('../assets/icons/notifications/notifications6x.png'),
  profile: require('../assets/icons/profile/profile10x.png'),
  dateRange: require('../assets/icons/dateRange/dateRange6x.png'),
}

//PLEASE KEEP ALPHABETICAL ORDER
export const images = {
  firstLoginCover: require('../assets/images/firstLogin/firstLogin.png'),
  mainLogo: require('../assets/images/mainLogo/logo.png'),
  mockCarousel1: require('../assets/images/carousel/londres.png'),
  mockCarousel2: require('../assets/images/carousel/cover-csds.png'),
  mockCarousel3: require('../assets/images/carousel/cover-del-valle-coco.png'),
  mockCarousel4: require('../assets/images/carousel/cover-green-tea.png'),
  mockCarousel5: require('../assets/images/carousel/obra0.png'),
  mockCarousel6: require('../assets/images/carousel/obra1.png'),
  mockCarousel7: require('../assets/images/carousel/obra2.png'),
  onboardingCardConstruction: require('../assets/images/onboarding/OnboardingCardConstruction.png'),
  onboardingCardFinancing: require('../assets/images/onboarding/OnboardingCardFinancing.png'),
  onboardingCardNotification: require('../assets/images/onboarding/OnboardingCardNotification.png'),
  onboardingCardWelcome: require('../assets/images/onboarding/OnboardingCardWelcome.png'),
  plainLogo: require('../assets/images/mainLogo/plainLogo.png'),
}
